module.exports = "/build/web/images/placeholder/article-index.64d5890bd833d884f47001ebb2f2f05c.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/placeholder/article-index.jpg
// module id = 136
// module chunks = 24